import { useTranslation } from 'react-i18next';
import Link from '@/components/LangLink/LangLink';
import NavLabel from '@/components/NavLabel/NavLabel';
import { splitTerm } from '@/utils/splitTerm';

export default function ChapterNav({ prev, next }) {
    const { t } = useTranslation();
    const prevSplit = prev ? splitTerm(prev.term) : null;
    const nextSplit = next ? splitTerm(next.term) : null;

    return (
        <nav className="chapter-nav" aria-label={t('navegacion paginas')}>
            {prev && (
                <Link
                    key={prev.web_path}
                    to={prev.web_path}
                    className={`button ${!next ? 'mr-auto' : ''}`}
                >
                    <div className="button--prev">
                        <NavLabel primary={prevSplit?.primary} secondary={prevSplit?.secondary} />
                    </div>
                </Link>
            )}
            {next && (
                <Link
                    key={next.web_path}
                    to={next.web_path}
                    className={`button ${!prev ? 'ml-auto' : ''}`}
                >
                    <div className="button--next">
                        <NavLabel primary={nextSplit?.primary} secondary={nextSplit?.secondary} />
                    </div>
                </Link>
            )}
        </nav>
    );
}
